<template>
  <div v-loading="loading">
    <el-row>
      <el-col :span="3" style="text-align: left">
        <el-switch
          :value="showSubmodel"
          active-color="#ffad53"
          inactive-color="#000"
          active-text="显示车款"
          @change="switchShowSubModel"
        ></el-switch>
      </el-col>
      <el-col :span="3" style="text-align: left">
        <el-button
          size="mini"
          @click="clearSelections"
          type="text"
          v-if="showClearAll"
          style="margin-top: -12px"
        >
          <svg-icon name="trash" size="28" color="#ffad53"></svg-icon>
          <span
            style="
              position: absolute;
              top: 4px;
              font-size: 14px;
              color: #ffad53;
            "
          >
            清空选择</span
          >
        </el-button>
        &nbsp;
      </el-col>

      <el-col :span="7">
        <el-select
          placeholder="选择已保存的搜索结果"
          size="mini"
          v-model="savedResultName"
          @change="onSelectedResultSchemaChanged"
          class="select-schema"
        >
          <el-option label="请选择" value="0"></el-option>
          <el-option
            v-for="(item, index) in savedResultSchemas"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-button size="mini" @click="saveResults" style="margin-left: 5px"
          >{{ schemaButtonLabel }}
        </el-button>
      </el-col>

      <el-col :span="3">
        <el-button type="text" @click="exportExcel" style="margin-top: -12px">
          <svg-icon name="download" size="22" color="#ffad53"></svg-icon>

          <span
            style="
              position: absolute;
              top: 4px;
              font-size: 14px;
              color: #ffad53;
            "
          >
            &nbsp;下载</span
          >
        </el-button>
      </el-col>
      <el-col :span="8" style="text-align: right; padding-right: 30px">
        <slot></slot>
      </el-col>
    </el-row>
    <el-table
      style="width: 100%; height: 500px"
      ref="selectedTable"
      height="450"
      :data="displayResult"
      @selection-change="onSelectionChanged"
    >
      <!-- <el-table-column
                type="selection"
                width="55">
            </el-table-column> -->

      <el-table-column label="厂商" prop="manufacturer"> </el-table-column>
      <el-table-column label="品牌" prop="brand"> </el-table-column>
      <el-table-column label="子车型" prop="model"> </el-table-column>
      <el-table-column v-if="showSubmodel" label="车款" prop="name" width="350">
      </el-table-column>

      <el-table-column v-if="showSubmodel" label="MSRP" sortable prop="msrp" :sort-method="sortMsrp">
      </el-table-column>
      <el-table-column
        v-if="showSubmodel"
        label="装备装态"
        sortable
        prop="equipstatus"
      >
      </el-table-column>
      <el-table-column
        label="停产"
        sortable
        prop="lineStatus"
        v-if="showSubmodel"
        :filter-method="filterMethod"
        :filters="getFilters('lineStatus')"
      >
      </el-table-column>
      <el-table-column
        label="车款年"
        sortable
        prop="lineYear"
        v-if="showSubmodel"
        :filter-method="filterMethod"
        :filters="getFilters('lineYear')"
      >
      </el-table-column>
      <el-table-column label="来源" prop="domestic"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="80">
        <template slot-scope="scope">
          <el-button @click.prevent="deleteRow(scope.row)" type="text">
            移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :visible.sync="showSaveResultNameInput"
      :center="false"
      :append-to-body="true"
      title="搜索结果名称"
    >
      <span slot="dialog-title">保存搜索结果</span>
      <el-input v-model="schemaName"></el-input>
      <span slot="footer">
        <el-button @click="hideNameInput">取消</el-button>
        <el-button @click="confirmSaveResult" type="primary">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="showSelectDatetime"
      :center="false"
      :append-to-body="true"
      title="选择分析时间"
    >
      <el-row :gutter="20">
        <el-col :span="14">
          <span slot="dialog-title">选择分析时间</span>
          <el-date-picker
            type="daterange"
            v-model="daterange"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-col>
        <el-col :span="10">
          <el-select v-model="dataSource" placeholder="请选择数据来源">
            <el-option label="中汽协"> </el-option>
            <el-option label="乘联会"> </el-option>
          </el-select>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="onHideSelectDatetime">返回</el-button>

        <el-button @click="gotoAnalyze" type="primary">生成透视表</el-button>
      </span>
    </el-dialog>
  </div>
</template>
 
<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import { async } from "q";
import XLSX from "xlsx";
import GUID from "../../store/guid";
export default {
    props: {
 
  moduleName: {
    type: String,
    required: true,
  },
    },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      selectedResult: [],

      schemaName: "新方案",
      savedResultName: "",
      showSaveResultNameInput: false,
      showSelectDatetime: false,
      loading: false,
      daterange: null,
      dataSource: "",
    };
  },

  methods: {
    ...mapMutations("commonsearch", [
      "deleteSelectionResult",
      "setPivotTableKey",
      "setShowSelectionSubmodel",
      "clearSelection",
    ]),
    ...mapActions("commonsearch", [
      "saveSelectionResultSchema",
      "initSavedResultSchema",
      "loadResultSchemaData",
      "savePivotTableAsync",
    ]),

    setDefaultFilterValue() {
      // this.$refs.resultTable.getTableRef().columns[7].filteredValue = ['在产'];

      this.$nextTick(() => {
        //this.$refs.resultTable.columns[7].filteredValue = ['在产'];
        this.$refs.selectedTable.store.states.columns.forEach((column) => {
          if (column.filteredValue && column.filteredValue.length) {
            this.$refs.selectedTable.store.commit("filterChange", {
              column,
              values: column.filteredValue,
              silent: true,
            });
          }
        });
      });
    },
     sortMsrp(x,y){
         return Number(x.msrp)-Number(y.msrp);
    },
    switchShowSubModel(val) {
      this.setShowSelectionSubmodel(val);
    },
    onShowSelectDatetime() {
      this.showSelectDatetime = true;
    },
    onHideSelectDatetime() {
      this.showSelectDatetime = false;
    },
    onSelectedResultSchemaChanged(val) {
      if (val === "0") {
        //pass
      } else {
        this.loading = true;
        this.loadResultSchemaData({ id: val, cb: this.updateLoadStatus });
        // this.switchSavedResultSchema(val);
        // this.$store.commit('startLoading', null, {root: true});
      }
    },
    updateLoadStatus(loadded) {
      this.loading = !loadded;
    },
    confirmSaveResult() {
      //let ids =  this.searchResult.map((item) =>{return item.id;});
      this.hideNameInput();
      this.saveSelectionResultSchema({
        schemaId: "",
        name: this.schemaName,
        module:this.moduleName, 
        action: "add",
        cb: this.onSaved,
      });
    },
    onSaved(res) {
      this.$message({
        message: res ? "已保存" : "保存失败",
        duration: 2000,
      });
    
    },

    //保存结果
    saveResults() {
      if (this.savedResultName == "" || this.savedResultName == "0") {
        this.showSaveResultNameInput = true;
      } else {
        //alert('编辑');
        this.saveSelectionResultSchema({
          schemaId: this.savedResultName,
          name: this.schemaName,
          module:this.moduleName,
          action: "update",
          cb: this.onSaved,
        });
      }
    },
    clearSelections() {
      this.clearSelection();
    },
    // 隐藏名称输入
    hideNameInput() {
      this.showSaveResultNameInput = false;
    },
    // 搜索结果列表
    onSelectionChanged(val) {
      if (this.showSubmodel) {
        this.selectedResult = val;
      } else {
        this.selectedResult = this.searchResult.filter((item) => {
          return (
            val.findIndex((obj) => {
              return item.model === obj.model;
            }) > -1
          );
        });
      }
    },
    // 过滤
    filterMethod(value, row, col) {
      const prop = col["property"];
      return row[prop] == value;
    },
    // 生成过滤列表
    getFilters(prop) {
      const result = this.searchResult;
      return result
        .map((item) => {
          return { text: item[prop], value: item[prop] };
        })
        .filter((item, index, arr) => {
          return (
            arr.findIndex((obj) => {
              return item.value === obj.value;
            }) === index
          );
        });
    },
    // 删除数据行
    deleteRow(rowData) {
      if (this.showSubmodel) {
        this.deleteSelectionResult({ id: rowData.id });
      } else {
        // 删除一个类型
        this.deleteSelectionResult({ model: rowData.model });
      }
    },
    // 进入分析
    gotoAnalyze() {
      if (this.daterange == null) {
        this.$message({
          type: "error",
          message: "没有选择日期",
          duration: 2000,
        });
        return;
      }
      var key = new GUID().newGUID();
      this.savePivotTableAsync({ key: key, cb: this.gotoPivotTable });
    },
    gotoPivotTable(key) {
      this.$router.push({
        name: "flexmonster",
        query: {
          datatype: "selection",
          pivotTableKey: key,
        },
      });
    },
    exportExcel() {
      // JSONToExcel(this.daliyReportList, "日报", "dayily_report");
      var title = this.showSubmodel ? "车款" : "子车型";
      var worksheet = XLSX.utils.json_to_sheet(this.displayResult);
      var new_workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        new_workbook,
        worksheet,
        this.getNowFormatDate() + title
      );
      XLSX.writeFile(new_workbook, this.getNowFormatDate() + "_report.xlsx");
    },
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
  },
  mounted() {
 
    this.initSavedResultSchema({moduleName:this.moduleName});
    this.setDefaultFilterValue();
  },
  computed: {
    ...mapGetters("commonsearch", {
      searchResult: "selectionResult",
      savedResultSchemas: "savedResultSchemas",
      pivotTableKey: "pivotTableKey",
      showSubmodel: "showSelectionSubmodel",
    }),
    showClearAll() {
      return this.searchResult.length > 0;
    },
    // 显示数据
    displayResult() {
      if (this.showSubmodel) {
        return this.searchResult;
      } else {
        // 最小颗粒为子车型
        return this.searchResult.filter((item, index) => {
          return (
            this.searchResult.findIndex((obj) => {
              return obj.model === item.model;
            }) === index
          );
        });
      }
    },

    schemaButtonLabel() {
      if (this.savedResultName == "" || this.savedResultName == "0") {
        return "保存搜索结果";
      } else {
        return "编辑搜索结果";
      }
    },
  },
};
</script>
